<template>
    <div class="material-view view" :class="{ vertex: state.vertex }">
        <instructions titleKey="worktopMaterial" :property="state.productFamily == 'seven' ? 'materialHelpContent' : 'materialHelpContentOne'" />

        <worktop-drawing />

        <div class="wrapper">
            <div class="section-content">
                <h2 class="h2" v-html="ui.t('worktopMaterialChoose')"></h2>

                <option-list v-model="materialCode"
                    :optionList="ui.materials"
                    :withImages="true"
                    :valueChangedText="'materialWasChanged'"
                    classes="big materials"
                    :enableZoom="true"
                    imageScaling="full"
                    :linkText="ui.t('worktopMaterialPreviewLinkText')"
                    :itemClasses="[ 'col-2-4' ]" />
            </div>
        </div>

        <div class="navigation">
            <div class="wrapper">
                <router-link :to="`/${state.productFamilyCode}/worktop`" v-html="ui.t('previous')" />
                <router-link :to="`/${state.productFamilyCode}/sink`" @click.native="moveNext" :class="{ next: true, disabled: !ui.materialSelectionsComplete }">
                    <span class="input-tip" v-if="moveNextPrevented" v-html="ui.t('selectionsIncomplete')"></span>
                    <span v-html="ui.t('next')"></span>
                </router-link>
            </div>
        </div>

    </div>
</template>

<script async setup lang="ts">
import { computed, ref } from 'vue';
import { useState, useUI } from '../store';

const moveNextPrevented = ref(false);
let moveNextTimer: number | null = null;

const { state } = useState();
const { ui } = useUI();

function moveNext() {
    moveNextPrevented.value = true;

    moveNextTimer = setTimeout(() => moveNextPrevented.value = false, 3000);
}

const materialCode = computed({
    get() {
        if (!state.material && !state.graphics)
            return null;

        return state.material == "K" || state.material == "F" ? state.material : (state.graphics || "0");
    },
    set(value: string) {
        //Material is 0, if anything else but deko or ONE matt is selected
        state.material = (value == "K" || value == "F") ? value : "0";

        if (!state.functionalAreaCode || state.functionalAreaCode == "0") {
            //Set graphics if material is anything but deko
            state.graphics = value != "K" && value != "F" ? value : null;
        }
        else {
            // Functional area always includes NN graphic (ONE functional area pattern)?
            // Functional area also requires material to be ONE MATT
            state.material = "F";
            state.graphics = "NN";
        }
    }
});
</script>
